import React from "react";
import "./Vacancies.css";

export default function Vacancies() {
  return (
    <div className="vacancies-page">
      {/* --- HireEdge hero --- */}
      <div className="hireedge-hero" role="region" aria-label="HireEdge hero">
        <div className="hireedge-hero__inner">
          <section className="hireedge-hero__left">
            

            <h1 className="hireedge-hero__title">
              <span>Careers at</span>
              <span className="accent">Careplus Homes</span>
            </h1>

            <p className="hireedge-hero__copy">
              We’re always looking for passionate, caring, and skilled individuals to join us. 
              Explore our current opportunities below.
            </p>

            <a className="hireedge-hero__cta" href="/jobs">
              Discover Jobs
            </a>
          </section>

          <aside className="hireedge-hero__right" aria-hidden="true">
            <img
              className="hireedge-hero__image"
              src="/Hiring.jpg"
              alt="Two colleagues reviewing work at a desk"
              loading="lazy"
            />
          </aside>
        </div>
      </div>






{/* ————— Discover Highlighted Jobs (drop-in section) ————— */}
<div className="highlighted-jobs-section" role="region" aria-label="Highlighted jobs">
  <h2 className="hj-title">
    <span>Discover </span>
    <span className="accent">Highlighted</span>
    <span> Jobs</span>
  </h2>

  <div className="hj-grid">
    {/* Card 1 */}
    <article className="job-card">
      <div className="job-card__media">
        <img src="childr.jpg" alt="Code on a laptop screen" />
      </div>
      <div className="job-card__content">
        <div className="job-card__company">Careplus Homes</div>
        <h3 className="job-card__title">Residential Support Worker</h3>
        <p className="job-card__desc">
         Provide day-to-day care, support, and guidance for children living in our homes. Create a safe, structured, and nurturing environment that helps children build confidence.
        </p>
        <div className="job-card__salary">Salary : <strong>£26,000+</strong></div>
        <div className="job-card__chips">
         
          <span className="chip">Full time</span>
          <span className="chip chip--icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/></svg>
            Manchester
          </span>
        </div>
      </div>
    </article>

    {/* Card 2 */}
    <article className="job-card">
      <div className="job-card__media">
        <img src="childr2.jpg" alt="Marketer at desk" />
      </div>
      <div className="job-card__content">
        <div className="job-card__company">CarePlus Homes</div>
        <h3 className="job-card__title">Senior Residential Support Worker</h3>
        <p className="job-card__desc">
         Play a vital leadership role in supporting children and guiding staff within the home. 
         Oversee shifts, mentor colleagues, and ensure children receives high-quality care.
        </p>
        <div className="job-card__salary">Salary : <strong>£33,500+</strong></div>
        <div className="job-card__chips">
         
          <span className="chip">Full time</span>
          <span className="chip chip--icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/></svg>
            Manchester
          </span>
        </div>
      </div>
    </article>

    {/* Card 3 */}
    <article className="job-card">
      <div className="job-card__media">
        <img src="childr3.jpg" alt="Analytics dashboards on screen" />
      </div>
      <div className="job-card__content">
        <div className="job-card__company">CarePlus Homes</div>
        <h3 className="job-card__title">Deputy Manager</h3>
        <p className="job-card__desc">
         Support the Registered Manager in the smooth running of the home. 
         Ensure regulatory standards are met while creating a positive environment for children.
        </p>
        <div className="job-card__salary">Salary : <strong>£32,000</strong></div>
        <div className="job-card__chips">
          
          <span className="chip">Full time</span>
          <span className="chip chip--icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/></svg>
            Manchester
          </span>
        </div>
      </div>
    </article>

    {/* Card 4 */}
    <article className="job-card">
      <div className="job-card__media">
        <img src="childr4.jpg" alt="Person writing content" />
      </div>
      <div className="job-card__content">
        <div className="job-card__company">CarePlus Homes</div>
        <h3 className="job-card__title">Registered Manager</h3>
        <p className="job-card__desc">
          Seeking an experienced and inspirational Registered Manager to lead one of our children’s homes. 
          You’ll be responsible for compliance, team leadership, and ensuring outstanding care for every child.
        </p>
        <div className="job-card__salary">Salary : <strong>£52,000</strong></div>
        <div className="job-card__chips">
          <span className="chip">Full time</span>
          <span className="chip chip--icon">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"/></svg>
            Manchester
          </span>
        </div>
      </div>
    </article>
  </div>
</div>






    </div>
  );
}
